//// Application Packages
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

//// Application Slices
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Carbon Components
import { Select, SelectItem } from '@carbon/react'

//// Application Components

//// Carbon Icons

//// Static Constants

//////// Component
const CountySelectorComponent = ({
    digital_name,
    value_key,
    country,
    state,
}) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        try {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        } catch (error) {
            console.warn('Revalidation Error:', error)
            return null
        }
    }

    // Handle Data Of All Fields
    const handleData = (e) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        }

        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (digital_name && value_key && country === 'US' && state !== 'FL') {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.[value_key]
                    }
                    value={formsData?.[digital_name]?.values?.[value_key]}
                    helper=""
                    labelText="County:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.[value_key]}
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="OUT OF STATE" value="79" />
                </Select>
            </>
        )
    } else if (
        digital_name &&
        value_key &&
        (country === '' || country === undefined || country === 'US')
    ) {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.[value_key]
                    }
                    value={formsData?.[digital_name]?.values?.[value_key]}
                    helper=""
                    labelText="County:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.[value_key]}
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="ALACHUA" value="11" />
                    <SelectItem text="BAKER" value="12" />
                    <SelectItem text="BAY" value="13" />
                    <SelectItem text="BRADFORD" value="14" />
                    <SelectItem text="BREVARD" value="15" />
                    <SelectItem text="BROWARD" value="16" />
                    <SelectItem text="CALHOUN" value="17" />
                    <SelectItem text="CHARLOTTE" value="18" />
                    <SelectItem text="CITRUS" value="19" />
                    <SelectItem text="CLAY" value="20" />
                    <SelectItem text="COLLIER" value="21" />
                    <SelectItem text="COLUMBIA" value="22" />
                    <SelectItem text="MIAMI-DADE" value="23" />
                    <SelectItem text="DESOTO" value="24" />
                    <SelectItem text="DIXIE" value="25" />
                    <SelectItem text="DUVAL" value="26" />
                    <SelectItem text="ESCAMBIA" value="27" />
                    <SelectItem text="FLAGLER" value="28" />
                    <SelectItem text="FRANKLIN" value="29" />
                    <SelectItem text="GADSDEN" value="30" />
                    <SelectItem text="GILCHRIST" value="31" />
                    <SelectItem text="GLADES" value="32" />
                    <SelectItem text="GULF" value="33" />
                    <SelectItem text="HAMILTON" value="34" />
                    <SelectItem text="HARDEE" value="35" />
                    <SelectItem text="HENDRY" value="36" />
                    <SelectItem text="HERNANDO" value="37" />
                    <SelectItem text="HIGHLANDS" value="38" />
                    <SelectItem text="HILLSBOROUGH" value="39" />
                    <SelectItem text="HOLMES" value="40" />
                    <SelectItem text="INDIAN RIVER" value="41" />
                    <SelectItem text="JACKSON" value="42" />
                    <SelectItem text="JEFFERSON" value="43" />
                    <SelectItem text="LAFAYETTE" value="44" />
                    <SelectItem text="LAKE" value="45" />
                    <SelectItem text="LEE" value="46" />
                    <SelectItem text="LEON" value="47" />
                    <SelectItem text="LEVY" value="48" />
                    <SelectItem text="LIBERTY" value="49" />
                    <SelectItem text="MADISON" value="50" />
                    <SelectItem text="MANATEE" value="51" />
                    <SelectItem text="MARION" value="52" />
                    <SelectItem text="MARTIN" value="53" />
                    <SelectItem text="MONROE" value="54" />
                    <SelectItem text="NASSAU" value="55" />
                    <SelectItem text="OKALOOSA" value="56" />
                    <SelectItem text="OKEECHOBEE" value="57" />
                    <SelectItem text="ORANGE" value="58" />
                    <SelectItem text="OSCEOLA" value="59" />
                    <SelectItem text="PALM BEACH" value="60" />
                    <SelectItem text="PASCO" value="61" />
                    <SelectItem text="PINELLAS" value="62" />
                    <SelectItem text="POLK" value="63" />
                    <SelectItem text="PUTNAM" value="64" />
                    <SelectItem text="ST.JOHNS" value="65" />
                    <SelectItem text="ST.LUCIE" value="66" />
                    <SelectItem text="SANTA ROSA" value="67" />
                    <SelectItem text="SARASOTA" value="68" />
                    <SelectItem text="SEMINOLE" value="69" />
                    <SelectItem text="SUMTER" value="70" />
                    <SelectItem text="SUWANNEE" value="71" />
                    <SelectItem text="TAYLOR" value="72" />
                    <SelectItem text="UNION" value="73" />
                    <SelectItem text="VOLUSIA" value="74" />
                    <SelectItem text="WAKULLA" value="75" />
                    <SelectItem text="WALTON" value="76" />
                    <SelectItem text="WASHINGTON" value="77" />
                </Select>
            </>
        )
    } else {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.[value_key]
                    }
                    value={formsData?.[digital_name]?.values?.[value_key]}
                    helper=""
                    labelText="County:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.[value_key]}
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="FOREIGN" value="825" />
                </Select>
            </>
        )
    }
}

export default CountySelectorComponent
